export const DocumentCategory = {
  REPAIR: 1,
  CONTRACT: 2,
  SUPPLIER: 3,
  CART_SUPPLIER: 4,
  DEPARTMENT: 5,
  SCOPE: 6,
  PRODUCTSALE :7
};

export const DocumentCategoryType = {
  INCOMING_REPAIR: 1,
  OUTGOING_REPAIR: 2,
  PAPERWORK_REPAIR: 3,
  PAPERWORK_CONTRACT: 4,
  PAPERWORK_SUPPLIER: 5,
  PAPERWORK_CART_SUPPLIER: 6,
  PAPERWORK_DEPARTMENT: 7,
  PAPERWORK_SCOPE: 8,
  PAPERWORK_PRODUCT_SALE: 9
}